import { useMutation } from 'react-query';

import { useRequest } from '@frontend/api';
import type { MutationFunction } from '@frontend/api';

import type {
  BulkCopyQuoteFilesQueryVars,
  UseBulkCopyQuoteFilesParams,
} from './types';

export const useBulkCopyQuoteFiles: MutationFunction<
  null,
  BulkCopyQuoteFilesQueryVars,
  [UseBulkCopyQuoteFilesParams]
> = (params, { requestOptions, queryOptions } = {}) => {
  const { quoteId } = params;
  const urlPath = `/quotes/files/${quoteId}/bulk_copy`;
  const request = useRequest(requestOptions);

  return useMutation(
    (requestData) =>
      request(urlPath, {
        init: { method: 'POST', body: requestData },
      }),
    {
      ...queryOptions,
      mutationKey: ['quotes', 'quoteFiles', 'bulkCopy', params],
    },
  );
};
